<template>
    <transition name="fade">
        <div id="login" v-if="isVisible" @click="close">
            <div class="login" @click.stop>
                <div id="captcha-element"></div>
                <div class="login1">
                    <img src="../assets/image/login1.png" alt="">
                </div>
                <div class="login2">
                    <div class="login2_1">
                        <div class="cursor_1 login2_2" :class="titleIndex == i ? 'login2_3' : ''"
                            v-for="(item, i) in title" @click="select(i)" :key="i">{{ item }}</div>
                    </div>

                    <div class="login3 " v-show="titleIndex == 1">
                        <div class="login5">
                            <div class="login6">+86</div>
                            <el-input v-model="phone" placeholder="请输入手机号" maxlength="11">
                            </el-input>
                        </div>

                        <div class="login5">
                            <el-input v-model="code" placeholder="请输入验证码"></el-input>
                            <div id="get-code" class="login7 cursor_1" v-if="!codeTime">
                                发送验证码
                            </div>
                            <div class="login7" v-else>{{ time }} s</div>
                        </div>
                    </div>
                    <div class="login3" v-if="titleIndex == 0">
                        <!-- <WxLogin :appid="appId" :scope="scope" :redirect_uri="redirect_uri" :href="href"></WxLogin> -->
                         <WxScanQRCode/>
                    </div>
                    <div class="login3">
                        <div class="login_btn cursor_1" @click="login" v-if="titleIndex === 1">登录</div>
                    </div>

                    <label class="login_cursor" @click="ifagree = !ifagree">
                        <div class="login_btn1 ">
                            <!-- <img :src="ifagree ? iconSelect[0] : iconSelect[2]"> -->
                            <div class="login_btn2">登录即已阅读并同意 <span @click.stop="toProtocol(0)"
                                    class="cursor_1">《用户协议》</span> <span @click.stop="toProtocol(1)"
                                    class="cursor_1">《隐私权政策》</span>
                            </div>
                        </div>
                    </label>

                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import api from '@/api/api';
import data from '@/assets/data';
import { sendConvertData } from '@/utils/baidu'
// import WxLogin from './WxLogin.vue';
import WxScanQRCode from './WxScanQRCode.vue';
import { EventBus } from '@/utils/eventBus';
export default {
    components: {
        WxScanQRCode
    },
    data() {
        return {
            title: ['微信扫码登陆','验证码登录'], //标题
            iconSelect: data.iconSelect, //图标
            ifagree: true, //是否同意协议
            titleIndex: 0, //标题下标
            phone: '', //手机号
            code: "", //验证码
            codeTime: false, //是否倒计时
            time: 60, //倒计时
            isVisible: false,
            captcha: null, //验证码实例
            appId: "wx667c408182a06348",
            scope: "snsapi_login",
            redirect_uri: "https://qmzj.xueerd.com",
            href: "data:text/css;base64," + data.ewm,
            interval: null,//倒计时
        }
    },
    mounted() {
        EventBus.$on('openLogin', () => {
            this.openLogin();
        });
    },
    beforeDestroy() {
        EventBus.$off('openLogin');
        clearInterval(this.interval)
        this.captchaInstance = null
    },
    methods: {
        close() {
            this.isVisible = false;
        },
        openLogin() {
            this.isVisible = true
            this.$nextTick(() => {
                // 弹出式
                // eslint-disable-next-line no-undef
				window.initAliyunCaptcha({
                    SceneId: '19dci0hq', // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
                    prefix: 'pn3khw', // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
                    mode: 'popup', // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
                    element: '#captcha-element', //页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
                    button: '#get-code', // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
                    captchaVerifyCallback: captchaVerifyCallback, // 业务请求(带验证码校验)回调函数，无需修改
                    onBizResultCallback: onBizResultCallback, // 业务请求结果回调函数，无需修改
                    getInstance: getInstance, // 绑定验证码实例函数，无需修改
                    slideStyle: {
                        width: 300,
                        height: 40,
                    }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
                    language: 'cn', // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
                    region: 'cn' //验证码示例所属地区，支持中国内地（cn）、新加坡（sgp）
                })

                // 绑定验证码实例函数。该函数为固定写法，无需修改
                function getInstance(instance) {
                    this.captcha = instance;
                }

                const that = this
                async function captchaVerifyCallback(captchaVerifyParam) {
                    const verifyResult = {}
                    verifyResult.captchaResult = await that.getCode(captchaVerifyParam)
                    return verifyResult;
                }

                // 业务请求验证结果回调函数
                function onBizResultCallback(bizResult) {
                    console.log('业务请求验证结果回调函数=', bizResult)
                }
            })
        },
        // 获取验证码
        async getCode(verifyParam) {
            if (!(/^1[3456789]\d{9}$/.test(this.phone))) {
                this.$message({
                    message: "手机号码不合法，请重新输入",
                    type: "warning",
                });
                return
            }
            const params = {
                phone: this.phone,
                verifyParam: verifyParam,
                module: 'novel_pc'
            }
            if (this.interval) {
                clearInterval(this.interval);
            }
            const res = await api.getCode(params)
            let result = res.data == null || res.data
            if (res.code === 200) {
                this.$message.success('验证码已发送')
                this.codeTime = true;
                this.interval = setInterval(() => {
                    if (this.time <= 1) {
                        this.codeTime = false;
                        clearInterval(this.interval);
                        this.time = 60
                    } else {
                        // console.log(that.time)
                        this.time--;
                    }
                }, 1000);
            } else {
                this.$message.error(res.msg)
            }
            return result

        },
        //切换登录方式
        select(i) {
            this.titleIndex = i
        },
        //用户协议 隐私权政策
        toProtocol(i) {
            if (i == 0) {
                window.open('https://api.esrke.com/rest/novel/public/protocol?type=yszc&platform=pc')
            } else if (i == 1) {
                window.open('https://api.esrke.com/rest/novel/public/protocol?type=yhxy&platform=pc')
            }
        },
        // 登录
        login() {
            this.phoneLogin()
            // if (!this.ifagree) {
            //     this.phoneLogin()
            // } else {
            //     this.$message.warning(`请阅读并同意《用户协议》和《隐私权政策》`)
            // }
        },
        phoneLogin() {
            api.phoneLogin(this.phone, this.code).then((res) => {
                if (res.code === 200) {
                    this.$message({
                        message: "登录成功",
                        type: "success",
                    })
                    const token = res.data.access_token
                    localStorage.setItem('token_key', token)
                    api.getUserinfo().then(res1 => {
                        if (res1.code === 200) {
                            if (!res1.data.signIn) {
                                api.setUserLoginState({ id: res1.data.id }).then(res2 => {
                                    const conversionTypes = {
                                        logidUrl: localStorage.getItem('logidUrl'),
                                        newType: 25,
                                        deviceType: 2
                                    }
                                    sendConvertData(conversionTypes).then(result => {
                                        console.log('调用转化成功=', result)
                                        window.location.reload()
                                        this.close()
                                    }).catch((err) => {
                                        console.log('调用转化失败=', err)
                                    })
                                })
                            } else {
                                window.location.reload()
                                this.close()
                            }
                        }
                    })
                } else {
                    this.$message.warning(res.msg)
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
#login {
    width: 100vw;
    height: 100vh;
    background: rgba(14, 14, 14, 0.2);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
}

.login {
    display: flex;
}

.login1 {
    width: 574px;
    height: 641px;
    overflow: hidden;
    border-radius: 24px 0 0 24px;
}
::v-deep(.el-input){
   .el-input__inner{
    border: 0 !important;
    background-color: transparent;
    font-size: 20px;
   }
}
.login1 img {
    width: 100%;
    height: 100%;
}

.login2 {
    width: 671px;
    height: 641px;
    background-color: #FFFFFF;
    border-radius: 0 21px 21px 0;
    padding: 85px 18px 95px 36px;
}

.login2_1 {
    display: flex;
    margin-bottom: 50px;
}

.login2_2 {
    font-size: 28px;
    color: #333333;
    margin-right: 15px;
}

.login2_2:last-child {
    margin-right: 0;
}

.login2_3 {
    font-weight: bold;
}

.login3 {
    display: flex;
    flex-flow: column;
    align-items: center;
}

.login5 {
    width: 580px;
    height: 68px;
    display: flex;
    align-items: center;
    padding: 0 17px;
    background-color: #F5F5F5;
    border-radius: 34px;
    margin-bottom: 35px;
}

.login5 .el-input {
    flex: 1;
}

.login5 .el-input__inner {
    border: none;
    background-color: #F5F5F5;
}

.login6 {
    font-weight: 400;
    font-size: 20px;
    line-height: 1;
    color: #333333;
    padding-right: 10px;
    border-right: 1px solid #AAAAAA;
    margin-right: 17px;
}

.login7 {
    margin-left: 17px;
    font-weight: 400;
    font-size: 18px;
    color: var(--tech-primary);
}

.login_btn {
    width: 580px;
    height: 68px;
    line-height: 68px;
    text-align: center;
    font-size: 24px;
    color: #FFFFFF;
    background: linear-gradient(93deg, #0089ff 0%, #005bac 100%);
    border-radius: 42px;
    cursor: pointer;
}

.login_btn1 {
    text-align: center;
    margin-top: 20px;
    font-size: 18px;
    color: #333333;
    display: flex;
    align-items: center;
    justify-content: center;
    /* cursor: pointer; */

}

.login_cursor {
    cursor: default !important;
}

.login_btn1 span {
    color: var(--tech-primary);
}

.login_btn1 img {
    width: 13px;
    height: 13px;
    margin-right: 8px;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
@media screen and (max-height:641px) {
    .login{
        zoom: 0.6;
    }
}
</style>